/**
 * @file paddle hackathon 首页
 * @author wanzhongyun
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'moment/locale/zh-cn';

import PaddleHackathon from './PaddleHackathon';

import './style.less';



moment.locale('zh-cn');

ReactDOM.render(<PaddleHackathon />, document.getElementById('root'));